import React from "react";
import { useParams } from "react-router-dom";
import Breadcrumb from "../../components/Breadcrumb";
import CTA from "../../components/CTA";
import bgImg from "../../assets/img/cta/cta-bg-2.png";
import Faq from "../../components/Faq";
import servicesData from "./servicesData";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import "./ServiceDetails.css";

const ServiceDetailsPage = () => {
  const { serviceId } = useParams();
  const service = servicesData[serviceId];

  // If serviceId is invalid, show an error message
  if (!service) {
    return (
      <main className="service-details">
        <Header
          parentMenu="service"
          headerClass="header__area header__transparent-2 header-width header-bg-color-2 header__mlr header__mt"
        />
        <Breadcrumb
          pageTitle="Service Not Found"
          description="Oops! The requested service does not exist. Please check the URL or explore our services."
        />
        <div className="container text-center mt-5">
          <h2>Oops! This service does not exist.</h2>
          <p>Please check the URL or explore our services.</p>
        </div>
        <Footer />
      </main>
    );
  }

  return (
    <main className="service-details">
      <Header
        parentMenu="service"
        headerClass="header__area header__transparent-2 header-width header-bg-color-2 header__mlr header__mt"
      />
      {/* Pass the correct service description to Breadcrumb */}
      <Breadcrumb
        pageTitle={service.title}
        description={service.breadcrumbDescription}
      />

      <div className="service-details__container">
        {/* Service Title & Description */}
        <div className="service-details__header">
          <h2 className="service-details__title">{service.title}</h2>
          <p className="service-details__description">{service.description}</p>
        </div>

        {/* Features Section */}
        <div className="service-details__features">
          <h3>Key Features</h3>
          <ul className="service-details__features-list">
            {service.features.map((feature, index) => (
              <li key={index} className="service-details__feature-item">
                ✅ {feature}
              </li>
            ))}
          </ul>
        </div>

        {/* Detailed Overview */}
        <div className="service-details__content">
          <h3>Detailed Overview</h3>
          <p>{service.content}</p>
        </div>

        {/* FAQ Section */}
        <div className="service-details__faq">
          <Faq />
        </div>
      </div>

      <CTA
        ctaBG={bgImg}
        Title={`Get Started with ${service.title}`}
        Description={`Ready to transform your business with our ${service.title}? Contact our team today to learn how we can help streamline your operations, improve efficiency, and drive growth.`}
        btnText="Get Started"
        btnURL={`/contact`}
      />
      <Footer />
    </main>
  );
};

export default ServiceDetailsPage;
